import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { map, get } from 'lodash';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';
import { convertDateToISOFormat } from 'utils/date';

@injectable()
class TaskService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  mapValuesToPayload = (data) => {
    const { assignees, customer, construction } = data;
    const assigneeIds = map(assignees, 'id');
    const customerId = get(customer, 'id');
    const constructionId = get(construction, 'id');
    const due = convertDateToISOFormat(data.due);

    return {
      ...data,
      due,
      assignees: assigneeIds,
      customer: customerId,
      construction: constructionId,
    };
  };

  async getTasks() {
    const result = await this.apiService.get('/organizer/tasks');
    return result;
  }

  async getTask(taskId) {
    const result = await this.apiService.get(`/organizer/tasks/${taskId}`);
    return result;
  }

  async addTask(data) {
    const payload = this.mapValuesToPayload(data);
    const result = this.apiService.post('/organizer/tasks', payload);
    return result;
  }

  async completeTask(taskId, resultTask) {
    const result = await this.apiService.post(`/organizer/tasks/${taskId}/complete`, {
      result: resultTask,
    });
    return result;
  }

  async closeTask(taskId) {
    const result = await this.apiService.post(`/organizer/tasks/${taskId}/close`);
    return result;
  }

  async reopenTask(taskId) {
    const result = await this.apiService.post(`/organizer/tasks/${taskId}/open`);
    return result;
  }

  async updateTask(taskId, data) {
    const payload = this.mapValuesToPayload(data);

    const result = await this.apiService.put(`/organizer/tasks/${taskId}`, payload);
    return result;
  }

  async deleteTask(taskId) {
    const result = await this.apiService.delete(`/organizer/tasks/${taskId}`);
    return result;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), TaskService, 0);

export default TaskService;
